import React from "react";
import { IconButton, colors } from "../../../design-system";
import { FullscreenButtonIcon, PlayPauseIcon } from "./InlineVideoPlayerIcons";
import { INLINE_VIDEO_PLAYER } from "../constants/inlineVideoPlayerText";

const overlayButtonSx = {
  position: "absolute",
  bottom: 4,
  color: colors.neutral.white,
  backgroundColor: colors.overlay.controlButton,
  "&:hover": { backgroundColor: colors.overlay.controlButtonHover },
  zIndex: 1,
};

interface PlayPauseButtonProps {
  paused: boolean;
  onClick: (e: React.MouseEvent) => void;
}

export const PlayPauseButton: React.FC<PlayPauseButtonProps> = ({ paused, onClick }) => (
  <IconButton
    ariaLabel={paused ? INLINE_VIDEO_PLAYER.PLAY : INLINE_VIDEO_PLAYER.PAUSE}
    size={32}
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      color: colors.other.black,
      backgroundColor: colors.overlay.videoPlay,
      "&:hover": { backgroundColor: colors.overlay.videoPlayActive },
      zIndex: 1,
    }}
  >
    <PlayPauseIcon paused={paused} />
  </IconButton>
);


interface FullscreenButtonProps {
  onClick: (e: React.MouseEvent) => void;
}

export const FullscreenButton: React.FC<FullscreenButtonProps> = ({ onClick }) => (
  <IconButton
    ariaLabel={INLINE_VIDEO_PLAYER.FULLSCREEN}
    size={20}
    onClick={onClick}
    sx={{ ...overlayButtonSx, right: 4 }}
  >
    <FullscreenButtonIcon />
  </IconButton>
);
